// /api/getUsers
import { fetchClass } from "../plugins/fetchAuth.ts";
import { getUrls } from "../plugins/config.ts";
import axios from "axios";
// const baseFida_URL = config.baseFida_URL;
// const baseSso_URL = config.baseSso_URL;
// var sso = "http://localhost:9000"; //config.sso;
// var coreURL = ""; //config.coreURL;
// import dummyData from "../core/json/dummyData/target.json"
export function APIgetStores(params) {
  params.body = {
    client_id: "aye9-qt1cj-abhrhzy7-m2tup-6x92kc5688",
    client_secret: "fp329-polk80s-ye04p1yy-45hx874z06",
  };
  var baseFida_URL = getUrls().baseFida_URL;
  return fetchClass(
    `${baseFida_URL}/api/getStores`,
    {
      method: "GET",
      body: { ...params.body },
    },
    {},
    false
  );
}
// export function APIgetUsers(params) {
//   params.body = {
//     client_id: "aye9-qt1cj-abhrhzy7-m2tup-6x92kc5688",
//     client_secret: "fp329-polk80s-ye04p1yy-45hx874z06",
//   };
//   return fetchClass(
//     `${baseSso_URL}/api/getUsers`,
//     {
//       method: "GET",
//       body: { ...params.body },
//     },
//     {
//       ...params.headers,
//     },
//     false
//   );
// }
//
export function APIgetBrands(params) {
  params.body = {
    client_id: "aye9-qt1cj-abhrhzy7-m2tup-6x92kc5688",
    client_secret: "fp329-polk80s-ye04p1yy-45hx874z06",
  };
  var baseFida_URL = getUrls().baseFida_URL;
  return fetchClass(
    `${baseFida_URL}/api/getStoreBrands`,
    {
      method: "GET",
      body: { ...params.body },
    },
    {
      ...params.headers,
    },
    false
  );
}

export const getCountries = async () => {
  // const countries = axios.get("https://flow-public-resource.s3.ap-northeast-1.amazonaws.com/static/countries/countries.json",{headers:null})
  const regions = await axios.get(
    "https://flow-public-resource.s3.ap-northeast-1.amazonaws.com/cities/cities.json",
    { headers: null }
  );
  // const states = axios.get("https://flow-public-resource.s3.ap-northeast-1.amazonaws.com/static/countries/states.json",{headers:null})
  const [rRegions] = await Promise.all([regions]);
  // let uniqueStates = [...new Map(rCities.map((item) => [item["prefecture"], item])).values()]
  // uniqueStates = uniqueStates.filter(item => item.prefecture) //  remove empty
  // let data = rCities?.regions.map(item => item.districts.map(v => v.prefectures)).flat()
  // let dataC = data?.map(item => item).flat()
  var rReg = rRegions?.data?.regions?.slice(1); // for
  return { cities: rReg, states: rReg };
  // return { countries: rCountries, cities: rCities, states: rStates }
};

export function createStore(params) {
  params.body = {
    client_id: "aye9-qt1cj-abhrhzy7-m2tup-6x92kc5688",
    client_secret: "fp329-polk80s-ye04p1yy-45hx874z06",
    ...params,
  };
  var baseFida_URL = getUrls().baseFida_URL;
  return fetchClass(
    `${baseFida_URL}/api/createStore`,
    {
      method: "POST",
      body: { ...params.body },
    },
    {
      ...params.headers,
    },
    false
  );
}
export function updateStore(params) {
  params.body = {
    client_id: "aye9-qt1cj-abhrhzy7-m2tup-6x92kc5688",
    client_secret: "fp329-polk80s-ye04p1yy-45hx874z06",
    ...params,
  };
  var baseFida_URL = getUrls().baseFida_URL;
  return fetchClass(
    `${baseFida_URL}/api/updateStore`,
    {
      method: "PUT",
      body: { ...params.body },
    },
    {
      ...params.headers,
    },
    false
  );
}

export function APIDeleteStore(params) {
  params.body = {
    client_id: "aye9-qt1cj-abhrhzy7-m2tup-6x92kc5688",
    client_secret: "fp329-polk80s-ye04p1yy-45hx874z06",
    storeId: params.id,
  };
  delete params.id;
  var baseFida_URL = getUrls().baseFida_URL;
  return fetchClass(
    `${baseFida_URL}/api/deleteStore`,
    {
      method: "DELETE",
      body: { ...params.body },
    },
    {
      ...params.headers,
    },
    false
  );
}

// role apis
export function APIgetRoles(params) {
  params.body = {
    client_id: "aye9-qt1cj-abhrhzy7-m2tup-6x92kc5688",
    client_secret: "fp329-polk80s-ye04p1yy-45hx874z06",
  };
  var baseSso_URL = getUrls().baseSso_URL;
  return fetchClass(
    `${baseSso_URL}/api/getRoles`,
    {
      method: "GET",
      body: { ...params.body },
    },
    {
      ...params.headers,
    },
    false
  );
}
// export function getPermissions(params) {
//   params.body = {
//     client_id: "aye9-qt1cj-abhrhzy7-m2tup-6x92kc5688",
//     client_secret: "fp329-polk80s-ye04p1yy-45hx874z06",
//   };
//   var obj = {
//     "status": 200,
//     "message": "Success",
//     "response": {
//       "permissions": [
//         {
//           "_id": "growth.ebuyings:store-manager:a:Update",
//           "title": "growth.ebuyings:store-manager:a:Update",
//           "module": "store-manager",
//           "section": "a",
//           "operation": "Update"
//         },
//         {
//           "_id": "growth.ebuyings:store-manager:a:Delete",
//           "title": "growth.ebuyings:store-manager:a:Delete",
//           "module": "store-manager",
//           "section": "a",
//           "operation": "Delete"
//         },
//         {
//           "_id": "growth.ebuyings:store-manager:a:Create",
//           "title": "growth.ebuyings:store-manager:a:Create",
//           "module": "store-manager",
//           "section": "a",
//           "operation": "Create"
//         },
//         {
//           "_id": "growth.ebuyings:store-manager:a:View",
//           "title": "growth.ebuyings:store-manager:a:View",
//           "module": "store-manager",
//           "section": "a",
//           "operation": "View"
//         },
//         {
//           "_id": "growth.ebuyings:users:a:Update",
//           "title": "growth.ebuyings:users:a:Update",
//           "module": "users",
//           "section": "a",
//           "operation": "Update"
//         },
//         {
//           "_id": "growth.ebuyings:users:a:Delete",
//           "title": "growth.ebuyings:users:a:Delete",
//           "module": "users",
//           "section": "a",
//           "operation": "Delete"
//         },
//         {
//           "_id": "growth.ebuyings:users:a:Create",
//           "title": "growth.ebuyings:users:a:Create",
//           "module": "users",
//           "section": "a",
//           "operation": "Create"
//         },
//         {
//           "_id": "growth.ebuyings:users:a:View",
//           "title": "growth.ebuyings:users:a:View",
//           "module": "users",
//           "section": "a",
//           "operation": "View"
//         },
//         {
//           "_id": "growth.ebuyings:roles-permissions:a:Update",
//           "title": "growth.ebuyings:roles-permissions:a:Update",
//           "module": "roles-permissions",
//           "section": "a",
//           "operation": "Update"
//         },
//         {
//           "_id": "growth.ebuyings:roles-permissions:a:Delete",
//           "title": "growth.ebuyings:roles-permissions:a:Delete",
//           "module": "roles-permissions",
//           "section": "a",
//           "operation": "Delete"
//         },
//         {
//           "_id": "growth.ebuyings:roles-permissions:a:Create",
//           "title": "growth.ebuyings:roles-permissions:a:Create",
//           "module": "roles-permissions",
//           "section": "a",
//           "operation": "Create"
//         },
//         {
//           "_id": "growth.ebuyings:roles-permissions:a:View",
//           "title": "growth.ebuyings:roles-permissions:a:View",
//           "module": "roles-permissions",
//           "section": "a",
//           "operation": "View"
//         },
//         {
//           "_id": "growth.ebuyings:operations:a:View",
//           "title": "growth.ebuyings:operations:a:View",
//           "module": "operations",
//           "section": "a",
//           "operation": "View"
//         },
//         {
//           "_id": "growth.ebuyings:marketing:a:View",
//           "title": "growth.ebuyings:marketing:a:View",
//           "module": "marketing",
//           "section": "a",
//           "operation": "View"
//         },
//         {
//           "_id": "growth.ebuyings:staffing:a:View",
//           "title": "growth.ebuyings:staffing:a:View",
//           "module": "staffing",
//           "section": "a",
//           "operation": "View"
//         },
//         {
//           "_id": "growth.ebuyings:analytics:a:View",
//           "title": "growth.ebuyings:analytics:a:View",
//           "module": "analytics",
//           "section": "a",
//           "operation": "View"
//         }
//       ]
//     },
//     "callName": "getTenantPermissionsNew"
//   };
//   return obj;

//   export function getPermissions(params) {
//   params.body = {
//     client_id: "aye9-qt1cj-abhrhzy7-m2tup-6x92kc5688",
//     client_secret: "fp329-polk80s-ye04p1yy-45hx874z06",
//   };
//   return fetchClass(
//     `${baseSso_URL}/api/getTenantPermissionsNew`,
//     {
//       method: "GET",
//       body: { ...params.body },
//     },
//     {
//       ...params.headers,
//     },
//     false
//   );
// }

//   // return fetchClass(
//   //   `${baseSso_URL}/api/getTenantPermissionsNew`,
//   //   {
//   //     method: "GET",
//   //     body: { ...params.body },
//   //   },
//   //   {
//   //     ...params.headers,
//   //   },
//   //   false
//   // );
// }
export function getPermissions(params) {
  params.body = {
    client_id: "aye9-qt1cj-abhrhzy7-m2tup-6x92kc5688",
    client_secret: "fp329-polk80s-ye04p1yy-45hx874z06",
    application: "growth.ebuyings",
  };
  params.headers = {
    ...params.headers,
  };

  var baseSso_URL = getUrls().baseSso_URL;
  return fetchClass(
    `${baseSso_URL}/api/getTenantPermissionsNew`,
    {
      method: "GET",
      body: { ...params.body },
    },
    {
      ...params.headers,
    },
    false
  );
}
export function createRole(params) {
  params.body = {
    client_id: "aye9-qt1cj-abhrhzy7-m2tup-6x92kc5688",
    client_secret: "fp329-polk80s-ye04p1yy-45hx874z06",
    ...params,
  };
  var baseSso_URL = getUrls().baseSso_URL;
  return fetchClass(
    `${baseSso_URL}/api/createRole`,
    {
      method: "POST",
      body: { ...params.body },
    },
    {
      ...params.headers,
    },
    false
  );
}
export function updateRole(params) {
  params.body = {
    client_id: "aye9-qt1cj-abhrhzy7-m2tup-6x92kc5688",
    client_secret: "fp329-polk80s-ye04p1yy-45hx874z06",
    ...params,
  };
  var baseSso_URL = getUrls().baseSso_URL;
  return fetchClass(
    `${baseSso_URL}/api/updateRole`,
    {
      method: "PUT",
      body: { ...params.body },
    },
    {
      ...params.headers,
    },
    false
  );
}
export function APIDeleteRole(params) {
  params.body = {
    client_id: "aye9-qt1cj-abhrhzy7-m2tup-6x92kc5688",
    client_secret: "fp329-polk80s-ye04p1yy-45hx874z06",
    _id: params.id,
  };

  var baseSso_URL = getUrls().baseSso_URL;
  return fetchClass(
    `${baseSso_URL}/api/deleteRole`,
    {
      method: "DELETE",
      body: { ...params.body },
    },
    {
      ...params.headers,
    },
    false
  );
}
// users api
export function APIgetUsers(params) {
  params.body = {
    client_id: "aye9-qt1cj-abhrhzy7-m2tup-6x92kc5688",
    client_secret: "fp329-polk80s-ye04p1yy-45hx874z06",
  };
  var baseSso_URL = getUrls().baseSso_URL;
  return fetchClass(
    `${baseSso_URL}/api/getUsers`,
    {
      method: "GET",
      body: { ...params.body },
    },
    {
      ...params.headers,
    },
    false
  );
}
// un assign
export function unassignUserStore(details) {
  details.body = {
    client_id: "aye9-qt1cj-abhrhzy7-m2tup-6x92kc5688",
    client_secret: "fp329-polk80s-ye04p1yy-45hx874z06",
    storeId: details.storeId,
    _id: details.userId,
  };
  var baseFida_URL = getUrls().baseFida_URL;
  return fetchClass(
    `${baseFida_URL}/api/unassignUserStore`,
    {
      method: "POST",
      body: { ...details.body },
    },
    {},
    false
  );
}
export function updateUserProfile(details) {
  details.body = {
    client_id: "aye9-qt1cj-abhrhzy7-m2tup-6x92kc5688",
    client_secret: "fp329-polk80s-ye04p1yy-45hx874z06",
    firstName: details.firstName,
    lastName: details.lastName,
    username: details.username,
    mobile: details.mobile,
    emailInfo: details.email,
    roleId: details.roleId,

    skillSets: details.skillSets, // hashed and split skillsets
    jobTitle: details.jobTitle,
    jobResponsibilities: details.jobResponsibilities,
    linkedinProfile: details.linkedinProfile,
    jobExperience: details.jobExperience,
    shiftStartTime: details.shiftStartTime,
    shiftEndTime: details.shiftEndTime,

    _id: details.id,
  };
  var baseSso_URL = getUrls().baseSso_URL;
  return fetchClass(
    `${baseSso_URL}/api/updateUserProfile`,
    {
      method: "PUT",
      body: { ...details.body },
    },
    {},
    false
  );
}
export function addUser(details) {
  const { ...restDetails } = details; // Create a shallow copy without the body property

  const bodyContent = {
    client_id: "aye9-qt1cj-abhrhzy7-m2tup-6x92kc5688",
    client_secret: "fp329-polk80s-ye04p1yy-45hx874z06",
    usersArray: [{ ...restDetails }],
    platform: "growth",
  };

  var baseSso_URL = getUrls().baseSso_URL;
  return fetchClass(
    `${baseSso_URL}/api/importUsers`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: bodyContent,
    },
    {},
    false
  );
}
export function setUserLocations(details) {
  details.body = {
    client_id: "aye9-qt1cj-abhrhzy7-m2tup-6x92kc5688",
    client_secret: "fp329-polk80s-ye04p1yy-45hx874z06",
    _id: details.userId,
    locations: details.locations,
  };
  var baseFida_URL = getUrls().baseFida_URL;
  return fetchClass(
    `${baseFida_URL}/api/setUserLocations`,
    {
      method: "POST",
      body: { ...details.body },
    },
    {},
    false
  );
}
export function updateUserPassword(details) {
  details.body = {
    client_id: "aye9-qt1cj-abhrhzy7-m2tup-6x92kc5688",
    client_secret: "fp329-polk80s-ye04p1yy-45hx874z06",
    locations: details.locations,
    newPassword: details.password,
    newConfirmPassword: details.newConfirmPassword,
    _id: details.id,
  };
  var baseSso_URL = getUrls().baseSso_URL;
  return fetchClass(
    `${baseSso_URL}/api/updateUserPassword`,
    {
      method: "PUT",
      body: { ...details.body },
    },
    {},
    false
  );
}
export function deleteUser(details) {
  details.body = {
    client_id: "aye9-qt1cj-abhrhzy7-m2tup-6x92kc5688",
    client_secret: "fp329-polk80s-ye04p1yy-45hx874z06",
    _id: details.id,
  };
  var baseSso_URL = getUrls().baseSso_URL;
  return fetchClass(
    `${baseSso_URL}/api/deleteUser`,
    {
      method: "DELETE",
      body: { ...details.body },
    },
    {
      ...details.headers,
    },
    false
  );
}
